// c:\Users\douco\Desktop\jaapand-e\src\pages\ResendVerification.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiMail, FiArrowLeft, FiSend } from 'react-icons/fi';
import { toast } from 'react-toastify';
import api from '../services/api';

const ResendVerification = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Veuillez entrer votre adresse e-mail.");
      return;
    }
    setLoading(true);
    try {
      await api.post('/auth/resend-verification', { email });
      toast.success("Si un compte existe avec cet email, un nouveau lien a été envoyé.");
    } catch (error) {
      toast.error(error.response?.data?.message || "Erreur lors de l'envoi.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="w-full max-w-md bg-white p-8 lg:p-10 rounded-2xl shadow-xl border border-gray-100">
        <div className="text-center mb-10">
          <h2 className="text-2xl font-bold font-poppins text-gray-900 tracking-tight">Renvoyer le lien</h2>
          <p className="text-gray-500 mt-2 text-sm">Entrez votre e-mail pour recevoir un nouveau lien d'activation.</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="email" className="block text-sm font-bold text-gray-700 mb-2 ml-1">Email</label>
            <div className="relative group">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-gray-400 group-focus-within:text-brand-blue transition-colors">
                <FiMail size={20} />
              </div>
              <input
                className="w-full pl-11 pr-4 py-3.5 rounded-xl bg-gray-50 border border-gray-100 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-blue/20 focus:border-brand-blue focus:bg-white transition-all duration-200"
                id="email" type="email" placeholder="votre@email.com"
                value={email} onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>

          <button 
            disabled={loading} 
            className="w-full flex justify-center items-center py-4 px-4 border border-transparent rounded-xl shadow-lg shadow-brand-blue/20 text-base font-bold text-white bg-brand-blue hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-blue transition-all duration-200 transform hover:-translate-y-0.5 disabled:opacity-75 disabled:cursor-not-allowed" 
            type="submit"
          >
            {loading ? 'Envoi en cours...' : (
                <>
                    <FiSend className="mr-2" /> Envoyer le lien
                </>
            )}
          </button>
          
          <p className="text-center text-sm mt-8">
            <Link to="/login" className="font-bold text-brand-blue hover:text-blue-700 transition-colors flex items-center justify-center"><FiArrowLeft className="mr-2" /> Retour à la connexion</Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default ResendVerification;
